export default {
  bonusesTxt: 'bonuses-txt',
  adminCostsTxt: 'admin-costs-txt',
  infrastructureTxt: 'infrastructure-txt',
  extraTxt: 'extra-txt',
};
